module.exports = __webpack_public_path__ + "static/media/loreal2.b7141d09.jpg";